(() => {
  const utils = window.ThemeSwiperUtils;
  if (!utils) return;

  utils.registerSectionSlider({
    key: 'flavor-slider',
    selectors: {
      sliderContainer: '[data-flavor-swiper]',
      swiperContainer: '[data-flavor-swiper-root]',
      previousButton: '[data-flavor-prev]',
      nextButton: '[data-flavor-next]',
      paginationContainer: '[data-flavor-pagination]',
      subtitleTargets: '[data-flavor-swiper-subtitle]',
    },
    watchResize: true,
    getSwiperOptions({
      sliderElement,
      swiperContainerElement,
      previousButtonElement,
      nextButtonElement,
      paginationContainerElement,
      spaceBetweenSlides,
      transitionSpeed,
    }) {
      return {
        slidesPerView: 1,
        spaceBetween: spaceBetweenSlides,
        speed: transitionSpeed,
        watchOverflow: true,
        nested: true,
        navigation: {
          prevEl: previousButtonElement,
          nextEl: nextButtonElement,
        },
        pagination: {
          el: paginationContainerElement,
          clickable: true,
          renderBullet: (index, className) =>
            `<button type="button" class="flavor-slider__dot ${className}" aria-label="Go to slide ${index + 1}"></button>`,
        },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true },
      };
    },
    onUpdate({ sliderElement, swiperInstance }) {
      const activeSlideElement = swiperInstance?.slides?.[swiperInstance.activeIndex];
      const subtitleText = activeSlideElement?.dataset?.subtitle || '';

      const subtitleTargets = sliderElement.querySelectorAll('[data-flavor-swiper-subtitle]');
      subtitleTargets.forEach((target) => {
        target.textContent = subtitleText;
      });

      // Some nested UI inside slides might need reflow
      window.dispatchEvent(new Event('resize'));
    },
  });
})();
